import React from 'react';
import SkillBar from './SkillBar';
import styled from 'styled-components';

const SkillsContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 10px;
  background: #f4f4f4;
  border-radius: 10px;
      padding: 20px;
    margin: 0 auto;
    max-width: 800px;
    font-size:10px;
     overflow-y: auto;
`;

// C, Java, Go Language, MongoDB, HTML, CSS, ReactJS, Python, JavaScript, PHP, SQL, MySQL, Figma, Power BI, Tableau, NetBeans,
// Postman API, Machine Learning, Deep Learning, Excel, Eclipse, DBMS, OOPS, Computer Networks, DSA.
// Soft Skills: Teamwork | Leadership | Public Speaking | Communication


const skills = [
  { skill: 'C,Java,Go,Python', percentage: 90 },
  { skill: 'HTML,CSS,JavaScript,ReactJS', percentage: 90 },
  { skill: 'MongoDB', percentage: 75 },
  { skill: 'PHP,SQL,MYSQL', percentage: 85 },
  { skill: 'Figma,Power BI,Tableau,NetBeans,Excel,Eclipse', percentage: 90 },
];
const skills1 = [
  { skill: 'Machine Learning', percentage: 90 },
  { skill: 'Deep Learning', percentage: 85 },
  { skill: 'Database Management System', percentage: 80 },
  { skill: 'Object Oriented Programming', percentage: 75 },
  { skill: 'Computer Networks', percentage: 80 },
  { skill: 'Data Structures and Algorithms', percentage: 75 },
];
const skills2 = [
  { skill: 'Teamwork', percentage: 90 },
  { skill: 'Leadership', percentage: 85 },
  { skill: 'Public Speaking', percentage: 80 },
  { skill: 'Communication', percentage: 75 },
];

const SkillsList = () => {
  return (
    <div>
    <SkillsContainer>
      {skills.map((item, index) => (
        <SkillBar key={index} skill={item.skill} percentage={item.percentage} />
      ))}
    </SkillsContainer>
    <br></br>
    <SkillsContainer>
      {skills1.map((item, index) => (
        <SkillBar key={index} skill={item.skill} percentage={item.percentage} />
      ))}
    </SkillsContainer>
    <br></br>
    <SkillsContainer>
      {skills2.map((item, index) => (
        <SkillBar key={index} skill={item.skill} percentage={item.percentage} />
      ))}
    </SkillsContainer>
    <br></br>
    </div>
  );
};

export default SkillsList;
